import { Role } from '../../../../enums/Role';
import { GetPermissionFn } from '../types';

export const getAddNewItemPermission: GetPermissionFn = ({
  workspace,
  hasRole
}) => {
  if (!workspace?.props?.allowAddNewItems) {
    return { canView: false, canEdit: false };
  }
  if (hasRole(Role.planningReadonly)) {
    return { canView: false, canEdit: false };
  }
  return { canView: true, canEdit: true };
};
